(function(){
  if(window.__ivBooted) return; window.__ivBooted = true;
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el){
    if(el.dataset.ivSplit) return; el.dataset.ivSplit = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function(w,i){
      var s = document.createElement('span');
      s.className = 'iv-w'; s.textContent = w;
      s.style.transitionDelay = (i * 0.045) + 's';
      el.appendChild(s);
      if(i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function countUp(el){
    var raw = el.dataset.ivCount; if(!raw) return;
    var m = raw.match(/-?\d+/); if(!m) { el.textContent = raw; return; }
    var target = parseInt(m[0],10), t0 = null, dur = 1400;
    function step(ts){
      if(!t0) t0 = ts;
      var p = Math.min((ts - t0)/dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = raw.replace(m[0], Math.round(target * eased));
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function boot(root){
    root = root || document;

    root.querySelectorAll('.iv-split:not([data-iv-split])').forEach(splitWords);

    var watch = root.querySelectorAll('.iv-rv:not(.is-in), .iv-split:not(.is-in), .iv-line:not(.is-in), [data-iv-count]:not([data-iv-done])');
    if(!('IntersectionObserver' in window) || RM){
      watch.forEach(function(e){ e.classList.add('is-in'); if(e.dataset.ivCount){ e.textContent = e.dataset.ivCount; e.dataset.ivDone='1'; } });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(x){
          if(!x.isIntersecting) return;
          var el = x.target;
          if(el.classList.contains('iv-rv')){
            var p = el.parentElement;
            var sib = p ? Array.prototype.filter.call(p.children, function(c){ return c.classList.contains('iv-rv'); }) : [];
            var i = sib.indexOf(el);
            el.style.transitionDelay = (i > 0 ? i * 0.085 : 0) + 's';
          }
          el.classList.add('is-in');
          if(el.dataset.ivCount && !el.dataset.ivDone){ el.dataset.ivDone = '1'; countUp(el); }
          io.unobserve(el);
        });
      }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });
      watch.forEach(function(e){ io.observe(e); });
    }

    // rail : glisser-deposer
    root.querySelectorAll('.iv-rail:not([data-iv-rail])').forEach(function(rail){
      rail.dataset.ivRail = '1';
      var down = false, x0 = 0, sl = 0;
      rail.addEventListener('pointerdown', function(e){ down = true; x0 = e.clientX; sl = rail.scrollLeft; rail.classList.add('is-drag'); });
      window.addEventListener('pointerup', function(){ down = false; rail.classList.remove('is-drag'); });
      rail.addEventListener('pointermove', function(e){ if(!down) return; rail.scrollLeft = sl - (e.clientX - x0); });
    });

    // galerie produit
    root.querySelectorAll('[data-iv-gallery]:not([data-iv-gal-done])').forEach(function(g){
      g.dataset.ivGalDone = '1';
      var main = g.querySelector('[data-iv-main]');
      g.querySelectorAll('[data-iv-th]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(!main) return;
          main.style.opacity = '0';
          setTimeout(function(){ main.src = btn.dataset.ivTh; main.style.opacity = '1'; }, 220);
          g.querySelectorAll('[data-iv-th]').forEach(function(b){ b.setAttribute('aria-current','false'); });
          btn.setAttribute('aria-current','true');
        });
      });
    });

    // pastilles de variantes
    root.querySelectorAll('[data-iv-variants]:not([data-iv-var-done])').forEach(function(box){
      box.dataset.ivVarDone = '1';
      var input = box.querySelector('[data-iv-vid]');
      box.querySelectorAll('[data-iv-v]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(btn.disabled) return;
          box.querySelectorAll('[data-iv-v]').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
          btn.setAttribute('aria-pressed','true');
          if(input) input.value = btn.dataset.ivV;
          var pr = document.querySelector('[data-iv-price]');
          if(pr && btn.dataset.ivPrice) pr.textContent = btn.dataset.ivPrice;
        });
      });
    });
  }

  // header : condense + masquage au defilement
  function header(){
    var hd = document.querySelector('.iv-hd'); if(!hd) return;
    var last = 0;
    window.addEventListener('scroll', function(){
      var y = window.scrollY;
      hd.classList.toggle('is-stuck', y > 30);
      if(y > 320 && y > last + 6){ hd.classList.add('is-hidden'); }
      else if(y < last - 6){ hd.classList.remove('is-hidden'); }
      last = y;
    }, { passive: true });
    var b = hd.querySelector('.iv-burger'), dr = document.querySelector('.iv-drawer');
    if(b && dr) b.addEventListener('click', function(){
      var open = hd.classList.toggle('is-open');
      dr.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
  }

  // barre de progression + derive douce
  function scrollFx(){
    if(RM) return;
    var bar = document.querySelector('.iv-prog');
    var drifts = Array.prototype.slice.call(document.querySelectorAll('.iv-drift'));
    var ticking = false;
    function run(){
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if(bar) bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
      var vh = window.innerHeight;
      drifts.forEach(function(el){
        var r = el.getBoundingClientRect();
        if(r.bottom < -200 || r.top > vh + 200) return;
        var sp = parseFloat(el.dataset.ivSpeed || '0.06');
        var mid = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (-mid * sp).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  function init(){ boot(document); header(); scrollFx(); }
  if(document.readyState !== 'loading'){ init(); } else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); header(); });
})();
